// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"59981813","39":"e0d647f4","247":"8983e325","281":"4383dc8a","472":"d7cb531d","489":"fa4a069e","491":"91b87026","510":"deb979a5","520":"5fa6bd20","611":"61472d42","685":"8c8eebe3","692":"ed10d9ec","723":"6bc2e55d","918":"6493dcbd","944":"ac3318c4","994":"2433025d"}[chunkId] + ".chunk.js";
};